import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2awlua1ssd: FaireBrandEntity = {
  token: "b_2awlua1ssd",
  type: "brand",
  name: "Golden Hour Designs",
  avatarUrl:
    "https://cdn.faire.com/fastly/1177829714af579a46ab05d3fe4571bd7434ec683193306bab3ee5769c98ddab.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/249c46b1da41a7f98be28020ec95276a2dae658b7ffe29d3d3b1fa2c7ca5d236.png",
  logoUrl:
    "https://cdn.faire.com/fastly/1177829714af579a46ab05d3fe4571bd7434ec683193306bab3ee5769c98ddab.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/249c46b1da41a7f98be28020ec95276a2dae658b7ffe29d3d3b1fa2c7ca5d236.png",
  location: "Sacramento, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 53,
  isInsider: true,
  description:
    "Bring joy to your space with unique & handmade home decor, hypoallergenic jewelry, fun accessories and more.\n\nRealizing her passions at a young age, Amanda has always been an entrepreneur. From selling drawings on her bedroom door as a child, to vending on the Official Vans Warped Tour at age 17, to starting her Health Coaching service at age 23. She knew that her calling was to create something with her own hands, put it out into the world and for it to serve a purpose; to bring joy to other people. Today she is a 31-year old based out of Sacramento, CA running the business and new storefront (with charm bar) while her incredible team handcrafts and assembles all of our products with love. ",
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:38:30.672Z",
    importedBy: "entity-db-cli",
  },
};
